export const maskEmail = (email) => {
  if (!email || !email.includes('@')) {
    return email;
  }

  const [localPart, domain] = email.split('@');

  // Handle edge cases for very short local parts
  if (localPart.length === 1) {
    // If 1 character, show as-is with domain
    return `${localPart}@${domain}`;
  } else if (localPart.length === 2) {
    // If 2 characters, mask the 2nd character
    return `${localPart[0]}*@${domain}`;
  } else if (localPart.length === 3) {
    // For 3 characters: show first, mask middle, show last
    return `${localPart[0]}*${localPart[2]}@${domain}`;
  }

  // For 4+ characters: show first 2, mask middle, show last 1
  const firstTwo = localPart.substring(0, 2);
  const lastChar = localPart[localPart.length - 1];
  const middleLength = localPart.length - 3; // Subtract first 2 and last 1
  const maskedMiddle = '*'.repeat(middleLength);

  return `${firstTwo}${maskedMiddle}${lastChar}@${domain}`;
};
